import * as Scrivito from "scrivito";
import React from "react";
import { debounce } from "lodash-es";
import { SearchInput } from "components";
import { useTranslate } from "hooks";
import { useProjectListContext } from "../../hooks/useProjectListContext";

export const ProjectSearchInput = Scrivito.connect(({ className }) => {
  const translate = useTranslate();
  const { setSearchQuery, searchQuery, setCurrentPageNo, currentPageNo } =
    useProjectListContext();

  const handleSearchQuery = ({ target: { value } }) => {
    const isValueValid = checkIsValidQuery(value);
    if (!searchQuery && !isValueValid) {
      return;
    }
    if (
      checkIsValidQuery(searchQuery) &&
      !isValueValid &&
      typeof value === "string" &&
      value.length > 0
    ) {
      return;
    }
    setSearchQuery(value || null);
    if (currentPageNo > 1) {
      setCurrentPageNo(1);
    }

    Scrivito.navigateTo(() => Scrivito.currentPage(), {
      params: {
        page: "1",
      },
    });
  };

  return (
    <SearchInput
      onChange={debounce(handleSearchQuery, 1000)}
      testId="SEARCH_FIELD"
      classNames={className}
      placeHolder={translate("SEARCH_FIELD_PLACEHOLDER")}
    />
  );
});

const checkIsValidQuery = (value) =>
  typeof value === "string" && value.length >= 3;
